import { render } from "./TheMessages.vue?vue&type=template&id=47903a39"
import script from "./TheMessages.vue?vue&type=script&lang=js"
export * from "./TheMessages.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__